import Link from 'next/link';
import Image from 'next/image';
import { PostStoryblok } from '@/types/types-storyblok';
import { getImageDimensions } from '@/storyblok/utils/asset';
import { StoryblokStory } from 'storyblok-generate-ts';
import clsx from 'clsx';

export const PostCard = ({ post, current, index }: { post: StoryblokStory<PostStoryblok>; current: boolean; index: number }) => {
  return (
    <li
      className={clsx('group px-4 lg:px-0 w-full flex-grow shrink-0 relative ', current ? 'z-10' : 'opacity-0')}
      style={{ transform: `translateX(calc(-${100 * index}%))` }}
    >
      <Link className="flex flex-col gap-4 h-full" href={'/' + post.full_slug}>
        {post.content.image?.filename ? (
          <Image
            className="rounded-xl w-full aspect-[1.21] object-cover bg-gray-300 lg:hidden"
            src={post.content.image.filename}
            alt={post.content.image.alt ?? 'immagine guida'}
            {...getImageDimensions(post.content.image)}
          />
        ) : (
          <div className="w-full aspect-[1.21] bg-gray-300 rounded-xl lg:hidden" />
        )}
        <div className="flex flex-row gap-4 items-center justify-between md:justify-start">
          <span className="text-elty-green bg-brandGreen-100 py-1 px-2 rounded">
            {post.content.categories?.map(category => (typeof category === 'string' ? category : category.name)).join(', ')}
          </span>
          {post.published_at && (
            <time className="text-text-body">
              {new Date(post.published_at).toLocaleString('it', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
              })}
            </time>
          )}
        </div>
        <h3 className="text-brandBlue-900 text-xl font-semibold line-clamp-2" title={post.content.title}>
          {post.content.title}
        </h3>
        <span className="text-elty-green font-semibold text-lg flex-grow flex flex-row justify-start items-center gap-2 transition-transform group-hover:translate-x-1">
          Leggi adesso
          <ArrowRightIcon />
        </span>
      </Link>
    </li>
  );
};

const ArrowRightIcon = () => (
  <svg className="size-5" fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" fill="#0bbca7" r="12" transform="matrix(-1 0 0 -1 24 24)" />
    <path d="m4.80005 4.80005h14.4v14.4h-14.4z" fill="#0bbca7" />
    <path
      clipRule="evenodd"
      d="m14.5682 11.6819c.1758.1757.1758.4606 0 .6363l-4.5 4.5c-.17569.1758-.46061.1758-.63635 0-.17574-.1757-.17574-.4606 0-.6364l4.18185-4.1818-4.18185-4.18175c-.17573-.17574-.17573-.46066 0-.6364.17574-.17574.46066-.17574.63635 0z"
      fill="#fff"
      fillRule="evenodd"
    />
  </svg>
);
